import { SocialEmbeds } from '@components/atoms/SocialEmbeds/SocialEmbeds';

export default function ContentElementSocialMedia(Element) {
  return <SocialEmbeds network={Element.network} id={Element.network_id || Element.id} />;
}
